export var formatScorer = function (player, stats) {
    var _a, _b, _c;
    if (!player)
        return undefined;
    if (stats === null || stats === void 0 ? void 0 : stats.goalsScored) {
        var goalsScored = stats.goalsScored === 1 ? "" : " (".concat(stats.goalsScored, ")");
        return "".concat((_b = (_a = player === null || player === void 0 ? void 0 : player.externalUser) === null || _a === void 0 ? void 0 : _a.lastName) !== null && _b !== void 0 ? _b : (_c = player === null || player === void 0 ? void 0 : player.user) === null || _c === void 0 ? void 0 : _c.lastName).concat(goalsScored);
    }
    return undefined;
};
/** Surname of a player who was sent off (a red recorded), else undefined. */
export var formatSentOff = function (player, stats) {
    var _a, _b, _c, _d, _e;
    if (!player)
        return undefined;
    if (((_a = stats === null || stats === void 0 ? void 0 : stats.redCards) !== null && _a !== void 0 ? _a : 0) > 0) {
        return ((_e = (_c = (_b = player === null || player === void 0 ? void 0 : player.externalUser) === null || _b === void 0 ? void 0 : _b.lastName) !== null && _c !== void 0 ? _c : (_d = player === null || player === void 0 ? void 0 : player.user) === null || _d === void 0 ? void 0 : _d.lastName) !== null && _e !== void 0 ? _e : undefined);
    }
    return undefined;
};
